export default __webpack_public_path__ + "static/media/maintanence.1f49e8e4.jpg";